import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../core/core.module';
import { MatDialogRef } from '@angular/material/dialog';
import { TerminosCondicionesComponent } from '../terminos-condiciones/terminos-condiciones.component';

@Component({
  selector: 'rpe-termino-condiciones-dialog',
  templateUrl: './termino-condiciones-dialog.component.html',
  styleUrls: ['./termino-condiciones-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TerminoCondicionesDialogComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(
    public dialogRef: MatDialogRef<TerminosCondicionesComponent>,
  ) {
  }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
